import { ChangeAction } from "api/api-types-publishing";
import type { ChipKind } from "mds/components/Chip";

export const chipKindForAction = (action: ChangeAction): ChipKind => {
  if (action === ChangeAction.delete) return "red";
  if (action === ChangeAction.create) return "blue";
  return "white";
};

export const ACTION_TRANSLATION_KEYS = {
  [ChangeAction.create]: "publishing.change_action.new",
  [ChangeAction.delete]: "publishing.change_action.deleted",
  [ChangeAction.update]: "publishing.change_action.update",
} as const;

export const CATEGORY_TRANSLATION_KEYS = {
  prep: "publishing.activity_category.prep",
  lesson: "publishing.activity_category.lesson",
  resource: "publishing.activity_category.resource",
  archive: "publishing.activity_category.archive",
} as const;
